//
// DataStyleCoordinator.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../GTLModel";
import "./DataStyleGroup";

var DataStyleCoordinator = createModule("gtl::DataStyleCoordinator", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getDataStyleGroup: [1,7],
        addDataStyleGroup: [0,1],
        removeDataStyleGroup: [0,1],
        getDataStyleGroups: [[1]],
    },
    {
        _create: [4],
    },
    ,
]);
export default DataStyleCoordinator;
